var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagProductWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.5H10.75C10.75 2.43 9.07 0.75 7 0.75C4.93 0.75 3.25 2.43 3.25 4.5H1.75C0.925 4.5 0.25 5.175 0.25 6V15C0.25 15.825 0.925 16.5 1.75 16.5H12.25C13.075 16.5 13.75 15.825 13.75 15V6C13.75 5.175 13.075 4.5 12.25 4.5ZM7 2.25C8.245 2.25 9.25 3.255 9.25 4.5H4.75C4.75 3.255 5.755 2.25 7 2.25ZM12.25 15H1.75V6H12.25V15ZM7 9C5.755 9 4.75 7.995 4.75 6.75H3.25C3.25 8.82 4.93 10.5 7 10.5C9.07 10.5 10.75 8.82 10.75 6.75H9.25C9.25 7.995 8.245 9 7 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagProductWhite);
export default __webpack_public_path__ + "static/media/bag-product-white.bd385c07260bd25f43db3b1e5f9bd714.svg";
export { ForwardRef as ReactComponent };